import { useContext } from 'react';

import { GaugeChartLoadingContext } from '../contexts/GaugeChartLoadingContext.js';

export const useGaugeChartLoadingContext = () =>
  useContext(GaugeChartLoadingContext);
